import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { T } from "react-translator-component";
import PostCard from "../../components/lists/PostCard";
import LoadingModal from "../../components/LoadingModal";
import LoadMoreButton from "../../components/LoadMoreButton";
import { Stack, Typography } from "@mui/material";
import DriveFileRenameOutlineIcon from "@mui/icons-material/DriveFileRenameOutline";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import appServices from "../../services/app-services/appServices";

export default function CommentHistory() {
  const { user } = useSelector((state: any) => state.userAuth);
  const [visible, setVisible] = useState(false);
  const navigate = useNavigate();
  const [commentHistory, setCommentHistory] = useState<any>([]);
  const [pagination, setPagination] = useState<any>({});

  useEffect(() => {
    if (user?.id) apiCalls(1);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  const apiCalls = async (page: number) => {
    if (!page) return

    setVisible(true);
    try {
      const posts = await appServices.getCommentHistoryPosts(page);
      const newItems = [...commentHistory, ...posts.posts];
      setCommentHistory(newItems);
      setPagination(posts.pagination);
    } catch (error) {
      // pass
    } finally {
      setVisible(false);
    }
  };

  return (
    <div>
      <div style={{ height: "100px" }}></div>
      <div style={{ marginLeft: 8 }} onClick={() => navigate(-1)}>
        <ArrowBackIosIcon />
      </div>
      <Stack
        direction="row"
        alignItems="center"
        justifyContent={"center"}
        spacing={2}
      >
        <DriveFileRenameOutlineIcon />
        <Typography style={{}}>{T("comment_history")}</Typography>
      </Stack>
      <div
        style={{
          width: "95%",
          height: 3,
          backgroundColor: "black",
          margin: 4,
        }}
      ></div>
      <LoadingModal visible={visible} />

      {commentHistory?.map((item: any, index: number) => (
        <PostCard
          post={item}
          key={index}
        />
      ))}

      <LoadMoreButton show={pagination?.next_page > 0} onClick={() => apiCalls(pagination?.next_page)} />
    </div>
  );
}
